import { render, staticRenderFns } from "./PurchaseOrderItemDetails.vue?vue&type=template&id=70b51dea&"
import script from "./PurchaseOrderItemDetails.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderItemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports